import React, { useEffect, useState, useRef, useCallback } from 'react';
import './History.css'; // Make sure the CSS file is in the same directory
import { useUserAuth } from "../context/UserAuthContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTrash, faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { set } from 'react-hook-form';
import axios from 'axios';
import { GPT_PROMPT_CONTENT }  from './Keywords';

const History = ({ isVisible, onClose, onSelectNote, getGPTResponse, hidden, nvoiceLogo}) => {
  const { setNeedUpdate, userDataLocal, transcriptDataBuffer, fetchTrascriptionData, user, updateTranscriptionData, updateVideoData, getVideoData, userVipLevel, setCurrentUpdateReason, checkToken, deleteHistory } = useUserAuth();
  const [searchQuery, setSearchQuery] = useState('');
  const [isVisibleHistory, setIsVisibleHistory] = React.useState(false);
  const [isVisibleHistorySub, setIsVisibleHistorySub] = React.useState(false);
  const [notes, setNotes] = useState(userDataLocal.History);
  const noteRefs = useRef(new Map()); // 存储每个 note 的 DOM 节点

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [noteToDelete, setNoteToDelete] = useState(null);
  // —————————————————————————————————————————————————

  useEffect(() => {
    setIsVisibleHistory(true);
    // setNotes(userDataLocal.History);
    if(notes){
      let array = notes;
      // 遍历userDataLocal.History数组
      let ifNoteIDExist = true;
      array.forEach((item, index) => {
        // 检查每个元素是否包含noteID字段
        if (!item.noteID) {
          ifNoteIDExist = false;
          // 如果不包含，则创建noteID，确保noteID只包含数字
          const dateNumbers = item.date.match(/\d+/g).join('');
          const startTimeNumbers = item.starttime.match(/\d+/g).join('');
          const endTimeNumbers = item.endtime.match(/\d+/g).join('');
          item.noteID = `${dateNumbers}${startTimeNumbers}${endTimeNumbers}${index}`;
        }
      });
      setNotes(array); //此处对notes进行更新的同时，也会更新userDataLocal.History，因此需要更新数据库
      if (!ifNoteIDExist) {
        setNeedUpdate(true);
        setCurrentUpdateReason('historyChanged');
      }
    }

    // —————————————————————————————————————————————————2024.12.06
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const noteID = entry.target.getAttribute('data-noteid');
            fetechTranscript(noteID);
            // console.log(`Visible noteID: ${noteID}`);
          }
        });
      },
      { threshold: 0.5 } // 元素至少 50% 可见时触发
    );

    // 观察所有 note 元素
    noteRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });
    // —————————————————————————————————————————————————2024.12.06

    return () => {
      setIsVisibleHistory(false);

      // —————————————————————————————————————————————————2024.12.06
      // 组件卸载时清除观察器
      observer.disconnect();
      // —————————————————————————————————————————————————2024.12.06
    };
  }, []);

  // —————————————————————————————————————————————————2024.12.06
  const setNoteRef = useCallback((node, noteID) => {
    if (node) {
      noteRefs.current.set(noteID, node);
    } else {
      noteRefs.current.delete(noteID);
    }
  }, []);

  const fetechTranscript = async(noteID) => {
    const noteExists = transcriptDataBuffer.some(item => item.noteID === noteID);
    const noteInUserDataLocal = userDataLocal.History.find(item => item.noteID === noteID);
    const transcriptExistInNote = noteInUserDataLocal && noteInUserDataLocal.transcript !== '';
    if (!noteExists && !transcriptExistInNote) {
      // const TandPandS = await fetchTrascriptionData(noteID); 
      let TandPandS = await fetchTrascriptionData(noteID); 
      // console.log('TandPandS:', TandPandS);
      if(TandPandS && TandPandS?.transcribeID && TandPandS?.transcribeID !== 'Done'){
        const transcribeID = TandPandS.transcribeID;
        let responseData = await checkTranscriptionStatus(transcribeID, noteID);

        if (TandPandS?.videoID && TandPandS?.videoURL && (!responseData?.transcriptionText || responseData?.transcriptionText === 'Transcript updating...')) {
          const videoData0417 = await getVideoData(TandPandS?.videoID, TandPandS?.videoURL);
          const { Transcript, subtitleWithTimestamp } = videoData0417;
          if (Transcript && Transcript !== '' && Transcript !== 'Transcript updating...') {
            responseData = {
              transcriptionText: Transcript,
              subtitleWithTimestamp: subtitleWithTimestamp
            };
          }
        }

        if(responseData){
          const speakerTranscrition = responseData.transcriptionText;
          const subtitleWithTimestamp = responseData.subtitleWithTimestamp;
          if (speakerTranscrition === null || speakerTranscrition === 'Transcript updating...') {
            console.log('Transcribing not completed or task failure, please try again later!');
          } else {
            const inputValueOfTandP = TandPandS.inputValue;
            const newNote = {
              ...TandPandS,
              inputValue: inputValueOfTandP === 'Transcript updating...' ? speakerTranscrition : inputValueOfTandP,
              transcript: speakerTranscrition,  
              subtitleWithTimestamp: subtitleWithTimestamp,
              transcribeID: 'Done'
            };
            updateTranscriptionData(newNote);
            TandPandS = newNote;

            const videoID = TandPandS?.videoID;
            if (videoID && TandPandS?.videoURL) {
              const newVideoData = { 
                Transcript: speakerTranscrition,
                subtitleWithTimestamp: subtitleWithTimestamp
              }
              updateVideoData(videoID, newVideoData);
            }
          }
        } else {
          console.error('Error fetching transcription data:', responseData);
        }
      } else if (!TandPandS && noteInUserDataLocal?.videoID && noteInUserDataLocal?.videoID !== '' && noteInUserDataLocal?.videoURL && noteInUserDataLocal?.videoURL !== '') {
        const videoId = noteInUserDataLocal.videoID;
        const videoUrl = noteInUserDataLocal.videoURL;
        const videoData = await getVideoData(videoId, videoUrl);
        if(videoData) {
          const { Duration, Language, PolishedText, Title, Transcript, AudioUrl, TranscribeID, subtitleWithTimestamp } = videoData;

          let transcriptText = Transcript;
          let polishedTextForGPT = PolishedText;
          let summaryText = '';
          let subtitleWithTimestampText = subtitleWithTimestamp;
          if ((!Transcript || Transcript === '' || Transcript == 'Transcript updating...') && TranscribeID) {
            const responseData = await checkTranscriptionStatus(TranscribeID, noteID);
            transcriptText = responseData?.transcriptionText;
            subtitleWithTimestampText = responseData?.subtitleWithTimestamp;
          }
          if (transcriptText === null || transcriptText === 'Transcript updating...' || transcriptText === '') {
            console.log('Transcribing not completed or task failure, please try again later!');
          } else {
            const textForGpt = TandPandS?.subtitleWithTimestamp || subtitleWithTimestampText || transcriptText;
            let gptVersion = 'gpt-4o-mini';
            const result = await getGPTResponse(textForGpt, userDataLocal?.SummarySet, userDataLocal?.SummaryLength, gptVersion, userDataLocal?.Language?.lan, userDataLocal?.GPTPromptContent || GPT_PROMPT_CONTENT.prompt, userVipLevel, polishedTextForGPT, Title, videoUrl);
            let polishedTextFromGPT = result.polishedText.replace(/\*\*/g, '');
            summaryText = result.summary.replace(/^Summary:/, '').replace(/\*\*/g, '');
            let keywordsText = result.keywords.replace(/^Keywords:/, '').replace(/\*\*/g, '');
            let outlineText = result.outline.replace(/^Outline:/, '').replace(/\*\*/g, '');
            let titleText = result.title.replace(/^Title:/, '').replace(/\*\*/g, '');
            let newChapterForMessages = TandPandS?.message || [];
            if(result?.chapters && result?.chapters !== 'Updating...' && (typeof result?.chapters === 'string' && result.chapters.trim() !== '')) {
              newChapterForMessages = [
                ...(newChapterForMessages || []),
                // 只有 chapters 有效时才追加
                ...(result.chapters ? [{
                  id: Date.now(),
                  user: 'Nvoice',
                  avatar: nvoiceLogo,
                  content: result.chapters,
                  timestamp: Date.now(),
                }] : [])
              ]
            }
            if(videoUrl && videoId){
              titleText = noteInUserDataLocal.title;
            }
            
            if(transcriptText || polishedTextFromGPT || summaryText){
              const newTranscriptBody = {
                noteID: noteInUserDataLocal.noteID,
                transcribeID: 'Done',
                inputValue: transcriptText,
                transcript: transcriptText,
                polishedText: polishedTextFromGPT,
                summary: summaryText,
                videoURL: videoUrl,
                videoID: videoId,
                keywords: keywordsText,
                outline: outlineText,
                title: titleText,
                message: newChapterForMessages,
                subtitleWithTimestamp: subtitleWithTimestampText
              }
              updateTranscriptionData(newTranscriptBody);
              if(transcriptText !== Transcript || polishedTextFromGPT !== PolishedText) {
                const newVideoData = { Transcript: transcriptText, PolishedText: polishedTextFromGPT, subtitleWithTimestamp: subtitleWithTimestampText }
                if(videoId) updateVideoData(videoId, newVideoData);
              }
              TandPandS = newTranscriptBody;
              setNotes(prevNotes => {
                let updated = false;
                const newNotes = prevNotes.map(note => {
                  if (note.noteID === noteInUserDataLocal.noteID) {
                    // 创建更新后的 note
                    const newNote = { ...note, keywords: keywordsText, outline: outlineText, title: titleText };
                    // 如果有变化则标记 updated 为 true
                    if (
                      note.keywords !== keywordsText ||
                      note.outline !== outlineText ||
                      note.title !== titleText
                    ) {
                      updated = true;
                    }
                    return newNote;
                  }
                  return note;
                });
                // 只有当确实更新了数据时才调用 setNeedUpdate(true)
                if (updated) {
                  setNeedUpdate(true);
                  setCurrentUpdateReason('historyChanged');
                }
                return newNotes;
              });
            }
          }
        }
      }
      if (user) {
        if (transcriptDataBuffer.length > 0) {
          if (transcriptDataBuffer[0] === user.uid && TandPandS) {
            // 如果第一个元素有值且等于 user.uid，则将TandPandS追加到transcriptDataBuffer中
            // console.log('TandPandS:', TandPandS);
            // setTranscriptDataBuffer( [...transcriptDataBuffer, TandPandS] );
          }
        } 
      }
    }
  }

  //2025.01.11
  const checkTranscriptionStatus = async (id, noteID) => {
    let timeoutId;
    try {
      // const response = await axios.get(`/api/checkTranscriptionStatus/${id}`);
      const response = await axios.get('/api/checkTranscriptionStatus', { 
        params: { id, uid: user.uid, noteIDnum: noteID }
      });
      if (response.data.status === 'Succeeded') {
        // console.log('Succeeded! Transcription is:', response.data.transcriptionText);
        // console.log('Succeeded! response.data.resdata:', response.data.resdata);
        return response.data;
      } else if (response.data.status === 'Failed') {
        console.error('Transcription failed, error or response.data is:', response.data.properties.error || response.data);
        return null;
      }  else {
        // console.log('Transcription is still in progress...');
        // console.log('response.data:', response.data);
        return {transcriptionText: 'Transcript updating...', subtitleWithTimestamp: ''};
      }
    } catch (error) {
      console.error('Error checking transcription status:', error);
      return null;
    }
  };
  // —————————————————————————————————————————————————2024.12.06

  useEffect(() => {
    setIsVisibleHistorySub(isVisibleHistory);
  }, [isVisibleHistory]);

  function handleClose () {
    setIsVisibleHistory(false);
    onClose();
  }

  // if (!isVisible) {
  //   setIsVisibleHistory(false);
  //   // return null;
  // }

  function calculateLength(starttime, endtime) {
    // Validate input to prevent errors
    if (!starttime || !endtime) {
        console.error("Invalid time input", { starttime, endtime });
        return "00:01";
    }

    try {
        // Parse start time
        let startHour = parseInt(starttime.split(':')[0]);
        let startMinutes = parseInt(starttime.split(':')[1].split(' ')[0]);
        let startAMPM = starttime.split(' ')[1];

        if (startAMPM === 'PM' && startHour < 12) startHour += 12;
        if (startAMPM === 'AM' && startHour === 12) startHour = 0; // Midnight case

        // Parse end time
        let endHour = parseInt(endtime.split(':')[0]);
        let endMinutes = parseInt(endtime.split(':')[1].split(' ')[0]);
        let endAMPM = endtime.split(' ')[1];

        if (endAMPM === 'PM' && endHour < 12) endHour += 12;
        if (endAMPM === 'AM' && endHour === 12) endHour = 0; // Noon case

        // Create date objects
        let start = new Date(`1970-01-01T${startHour.toString().padStart(2, '0')}:${startMinutes.toString().padStart(2, '0')}`);
        let end = new Date(`1970-01-01T${endHour.toString().padStart(2, '0')}:${endMinutes.toString().padStart(2, '0')}`);

        // Calculate duration
        let durationInMinutes = (end - start) / (1000 * 60);
        if (durationInMinutes < 0) {
            durationInMinutes += 24 * 60; // Account for overnight durations
        }

        let hours = Math.floor(durationInMinutes / 60);
        let minutes = Math.floor(durationInMinutes % 60);

        // 如果小时和分钟都为0，则将分钟设置为1
        if (hours === 0 && minutes === 0) {
          minutes = 1;
        }

        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    } catch (error) {
        console.error("Error calculating time length", error);
        return "00:01";
    }
  }

  function groupByDate(notesArray) {
    return notesArray.reduce((acc, note) => {
      const date = new Date(note.date).toLocaleDateString('en-US', {
        month: 'long', day: 'numeric', year: 'numeric'
      });
      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(note);
  
      // 在此处为每个日期分组排序笔记
      // acc[date].sort((a, b) => new Date(b.starttime) - new Date(a.starttime));
      // 在此处为每个日期分组排序笔记（按照 noteID 降序排序）
      acc[date].sort((a, b) => Number(b.noteID) - Number(a.noteID));
  
      return acc;
    }, {});
  }
  
  // 在分组后，确保组间顺序也是按照日期降序排列
  // const groupedNotes = Object.entries(groupByDate(notes))
  // .sort((a, b) => new Date(b[0]) - new Date(a[0])) // 按日期降序排列组
  // .reduce((acc, [date, notes]) => {
  //   // 在此处为每个日期分组排序笔记
  //   notes.sort((a, b) => {
  //     const aTime = new Date(`1970/01/01 ${a.starttime}`);
  //     const bTime = new Date(`1970/01/01 ${b.starttime}`);
  //     return bTime - aTime;
  //   });

  //   acc[date] = notes; // 转换回对象
  //   return acc;
  // }, {});

  // 在分组后，确保组间顺序也是按照日期降序排列
  const groupedNotes = Object.entries(groupByDate(notes))
  .sort((a, b) => new Date(b[0]) - new Date(a[0])) // 按日期降序排列组
  .reduce((acc, [date, notes]) => {
    // 为每个日期分组排序笔记（按照 noteID 降序排序）
    notes.sort((a, b) => Number(b.noteID) - Number(a.noteID));
    acc[date] = notes; // 转换回对象
    return acc;
  }, {});
  
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  
  const filteredNotes = Object.entries(groupedNotes).reduce((acc, [date, notes]) => {
    const filteredNotesForDate = notes.filter(note =>
      note.title.toLowerCase().includes(searchQuery.toLowerCase())
    );
  
    if (filteredNotesForDate.length > 0) {
      acc[date] = filteredNotesForDate;
    }
  
    return acc;
  }, {});

  //2024.12.06 preload note transcriptData

  const preloadNoteDetails = (note) => {
    console.log(`Preloading details for note: ${note}`);
    // 在这里实现实际的预加载逻辑（如从服务器获取详细信息）
  };
  
  // 模拟获取详细信息的函数
  const fetchNoteDetails = async (noteID) => {
    // 模拟异步 API 请求，实际应用中替换为真实 API 调用
    return new Promise((resolve) =>
      setTimeout(() => resolve({ noteID, details: "Detailed information" }), 1000)
    );
  };

  //________________________________________________________
  //2025.05.25 delete note
  // 显示删除确认对话框
  const handleDeleteClick = (e, note) => {
    e.stopPropagation(); // 阻止事件冒泡，避免触发选择笔记
    setNoteToDelete(note);
    setShowConfirmModal(true);
  };

  // 确认删除处理
  const handleConfirmDelete = async () => {
    if (!noteToDelete) return;
    setShowConfirmModal(false);
    try {
      // 1. 从本地状态中删除
      const updatedNotes = notes.filter(note => note.noteID !== noteToDelete.noteID);
      setNotes(updatedNotes);
      await deleteHistory(noteToDelete.noteID);

      // 3. 从transcriptDataBuffer中移除
      const updatedTranscriptBuffer = transcriptDataBuffer.filter(
        item => item.noteID !== noteToDelete.noteID
      );
      // 可能需要更新transcriptDataBuffer的地方，或者它会自动更新
      
      // 4. 标记需要更新到数据库
      
      setCurrentUpdateReason('historyDeleted');
      // setTimeout(() => {
      //   setNeedUpdate(true);
      // }, 100); 
      
      // 5. 关闭确认对话框

      setNoteToDelete(null);
      
    } catch (error) {
      console.error('Error deleting record: ', error);
      // 可以添加错误提示
    }
  };

  //________________________________________________________

    return (
      <div className={`popup-background-history ${isVisibleHistorySub ? 'active' : ''}`}>
        {/* <div style={{width: '100%', height: '85%'}}> */}
          {/* <div className={`popup-history${isVisibleHistorySub ? 'active' : ''}`}> */}
          <div className='popup-history' hidden={hidden}>
            <div className='header-history'>
              <h1 className='h1-history'>History</h1>
              <div className='search-container-history'>
                <FontAwesomeIcon icon={faSearch} className="search-icon-history lighter-icon" />
                <input className='input-history' type="search" placeholder="Search"  onChange={handleSearchChange} /> 
              </div>
              <span className="close-history" onClick={handleClose}>&times;</span>
            </div>
            <div className="content-history">
              {/* {Object.entries(groupedNotes).map(([date, notes]) => ( */}
              {Object.entries(filteredNotes).map(([date, notes]) => (
                <div key={date} className="date-group-history">
                  <div className="date-header-history">{date}</div>
                  {notes.map((note, index) => (
                    <div 
                      key={index} 
                      className="note-container-history"  
                      onClick={() => onSelectNote(note)}
                      data-noteid={note.noteID} 
                      ref={(node) => setNoteRef(node, note.noteID)} 
                    >
                      {/* <div><strong>{note.title.replace(/"/g, '')}</strong></div> */}
                      <div className="delete-note-header">
                        <strong>{note.title.replace(/"/g, '')}</strong>
                        <button 
                          className="delete-note-btn" 
                          onClick={(e) => handleDeleteClick(e, note)}
                          title="Deleting Records"
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      </div>
                      <div className='note-time-history'>{note.starttime}&nbsp;·&nbsp;{calculateLength(note.starttime, note.endtime)}&nbsp;min</div>

                      <div>{note.keywords.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()，。、《》？；：“”‘’]/g, ' ')}</div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        {/* </div> */}
        {/* 删除确认对话框 */}
        {showConfirmModal && (
          <div className="delete-confirm-modal">
            <div className="delete-confirm-content">
              {/* <h3>Confirm</h3> */}
              <p>Are you sure you want to delete this record? This operation is irreversible.</p>
              <div className="delete-confirm-buttons">
                <button 
                  onClick={() => setShowConfirmModal(false)}
                  className="delete-cancel-button"
                >
                  Cancel
                </button>
                <button 
                  onClick={handleConfirmDelete} 
                  className="delete-button"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      );
    };

export default History;